export const verifyPayment = (paymentDetails,paymentType = null) => {
  return {
    type: "VERIFY_PAYMENT",
    paymentDetails,
    paymentType
  };
};

export const transferFormToPaymentObj = paymentDetails => {
  return {
    type: "TRANSFER_FORM",
    paymentDetails
  };
};

export const setPayoffCheck = (payoffCheckObject) => {
  return {
    type: "SET_PAYOFF_CHECK",
    payload: payoffCheckObject,
  };
};

export const setAppraisalChargeFee = fee => {
  return {
    type: "SET_APPRAISAL_CHARGE_FEE",
    fee
  };
};

export const setFeeType = feeType => {
  return {
    type: "SET_FEE_TYPE",
    feeType
  };
};

export const submitPayment = (paymentDetails, paymentType) => {
  return {
    type: "SUBMIT_PAYMENT",
    paymentDetails,
    paymentType
  };
};

// Remove the payment error property to allow users to go back to the payment screen
// and make changes to their payment method
export const removePaymentErrorProperty = () => {
  return {
    type: "REMOVE_PAYMENT_ERROR"
  };
};



// WEBPACK FOOTER //
// ./src/actions/payment.actions.js